import React from "react";

const Logo = (props) => (
  <div className="formRow formLogoRow pt-5 pb-3">
    <div className={`brandLogo ${props.noText ? "noText" : ""}`} />
  </div>
);

export default Logo;
